import {z} from 'zod';

export const formSchema = z
	.object({
		code1: z.string(),
		code2: z.string(),
		code3: z.string(),
		code4: z.string(),
		code5: z.string(),
		code6: z.string(),
		code7: z.string(),
	})
	.refine(value => Object.values(value).every(val => val !== ''));

export type IFormData = z.infer<typeof formSchema>;
